import { Constants } from "../constants/constants";
import { ILoginForm } from "../Hooks/login.hook";

class LoginService {
  API: string;

  constructor() {
    this.API = process.env.REACT_APP_PUBLIC_AUTH_ENDPOINT || '';
  }

  async login(formValues: ILoginForm, reCaptchaToken: string) {
    try {
      const response = await fetch(this.API, {
        method: 'PUT',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'recaptcha-token': reCaptchaToken
        },
        body: JSON.stringify(formValues)
      });

      const data = await response.json();

      if (response?.type === 'error' || !response.ok) {
        return {
          type: 'error',
          result: { message: data?.message || Constants.DEFAULT_ERROR_MESSAGE },
          status: response.status
        } as const;
      }

      return { type: 'success', result: data };
    } catch (error) {
      return {
        type: 'error',
        result: error,
      } as const
    }
  }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new LoginService();